export enum ActionType {
    event = "event",
    link = "link",
    customEvent = "customEvent"
}